import { Link } from "react-router-dom";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="h-16 border-t flex items-center px-12">
      <div className="text-sm text-muted-foreground pl-4">
        © {year} Airloom AI Inc. - All Rights Reserved
      </div>
      <div className="flex-1 flex items-center justify-end pr-4 space-x-6">
        <Link
          to="/support"
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          Support
        </Link>
        <Link
          href="https://airloomai.net/privacy-policy"
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}
